module.exports = __webpack_public_path__ + "img/round-logo.e77c4809.png";